<template>
    <div>

        <!-- 开关 -->
        <el-switch v-model="inData" v-if="type == 'switch'"> </el-switch>
        <!-- 用户头像 -->
        <div v-else-if="type == 'avatar'">
            <img :src="inData" v-if="inData && inData != ''" class="avatar box-s" alt="" />
        </div>
        <!-- 小标签 -->
        <div v-else-if="type == 'tag'">
            <el-tag :type="config.type">
                {{ inData }}
            </el-tag>
        </div>
        <!-- 弹出框 -->
        <div v-else-if="type == 'popover'">
            <XPopover v-model="inData" :config="config"></XPopover>
        </div>
        <div v-else-if="type == 'icon'">
            <i :class="inData"></i>
        </div>
        <div v-else-if="type == 'btn'">
            <el-button type="primary" @click="update_func" size="small">{{ config.name }}</el-button>
        </div>
        <span v-else>

            {{ inData }}
        </span>
    </div>
</template>

<script>
import _ from 'lodash';
import { update } from 'lodash';
export default {

    props: {
        value: {
            type: [Object, Array, String, Number, Boolean],
            default: null
        },
        type: {
            type: String,
            default: 'str'
        },
        config: {
            type: null,
            default: null
        }
    },

    data() {
        return {
            inData: this.value
        }
    },
    watch: {
        value(newVal) {
            this.inData = newVal
        },
        inData(newVal) {
            if (!this.isEqual(newVal, this.value)) {
                this.$emit('input', _.cloneDeep(newVal)); // 值变化时通知父级
                this.update_func()
            }
        }
    },
    created() {

    },
    methods: {
        isEqual(a, b) {   // 智能值比对（处理所有数据类型）
            if (typeof a !== typeof b) return false;
            if (typeof a === 'object' && a !== null && b !== null) {  // 处理引用类型
                return _.isEqual(a, b); // 使用 lodash 深度比对
            }
            return a === b; // 基本类型直接比对
        },
        update_func() {
            this.$emit('change', true)
        }
    }
}
</script>

<style scoped></style>
